import { Injectable } from '@angular/core';
import { apiEndpoints } from './general.common';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CompletionUpdateRequest, CustomerActivationRequest, OrchestrationRequest, StagingUpdateRequest, ThunesPaymentOrderResponse } from '../general.model';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json').set('Cache-Control', 'no-cache');

  constructor(private http: HttpClient) { }

  getPayment(transactionId: string, statusMode: string): Observable<any> {
    return this.http.get<any>(apiEndpoints.getPayment(transactionId,statusMode),  { headers: this.headers });
  }

  activateStatus(activationId : string): Observable<any> {
      return this.http.get<any>(apiEndpoints.activateStatus(activationId), { headers: this.headers});
  }

  initiateActivate(customerActivationRequest: CustomerActivationRequest, correletorID:string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('X-Correlation-ID', correletorID);
    return this.http.post<any>(apiEndpoints.initiateActivate(),customerActivationRequest, { headers: headers});
  }

  thunesWebhook(thunesPaymentOrderResponse:ThunesPaymentOrderResponse): Observable<any> {
    let params = new HttpParams().set('X-Correlation-ID', "");
    return this.http.post<any>(apiEndpoints.thunesWebhook(),thunesPaymentOrderResponse, { headers: this.headers, params: params });
  }

  thunesStream(correlatorId:string): Observable<any> {
    return this.http.get<any>(apiEndpoints.thunesStream(correlatorId), { headers: this.headers});
  }

  initiateOrchestrator(xcorrelationID:string,partnerId:string,orchestrationRequest:OrchestrationRequest): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache')
      .set('X-Correlation-ID', xcorrelationID)
      .set('partnerId', partnerId);
    return this.http.post<any>(apiEndpoints.initiateOrchestrator(),orchestrationRequest, { headers: headers});
  }

  updatePaytment(correlationID:string,stagingUpdateRequest:StagingUpdateRequest): Observable<any> {
    return this.http.put<any>(apiEndpoints.updatePaytment(correlationID),stagingUpdateRequest, { headers: this.headers});
  }

  completePayment(correlationID:string,completionUpdateRequest:CompletionUpdateRequest): Observable<any> {
    return this.http.put<any>(apiEndpoints.completePayment(correlationID),completionUpdateRequest, { headers: this.headers});
  }

  getOpenPayments(): Observable<any> {
    return this.http.get<any>(apiEndpoints.getOpenPayments(), { headers: this.headers});
  }

}
